import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const workDataForm: Form<Client> = {
  key: 'workData',
  title: 'Arbeit',
  fields: [
    {
      key: 'graduation',
      label: 'Schulabschluss',
      fieldTypes: 'text',
    },
    {
      key: 'trainingQualification',
      label: 'Ausbildungsabschluss',
      fieldTypes: 'text',
    },
    {
      key: 'jobs',
      label: 'Arbeitsstellen',
      fieldTypes: 'headline',
    },
    {
      key: 'firstJob',
      label: 'Arbeitsstelle',
      fieldTypes: 'text',
    },
    {
      key: 'firstJobWage',
      label: 'Lohn',
      fieldTypes: 'number',
    },
    {
      key: 'secondJob',
      label: 'Arbeitsstelle',
      fieldTypes: 'text',
    },
    {
      key: 'secondJobWage',
      label: 'Lohn',
      fieldTypes: 'number',
    },

    {
      key: 'courses',
      label: 'Kurse / Maßnahmen',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
    {
      key: 'workNotice',
      label: 'Notizen',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default workDataForm;
